export default __webpack_public_path__ + "static/media/currency-usd.37d8ae61.svg";